<template>
  <modal
    name="detail-select"
    height="100%"
    classes="modal-wrapper"
    scrollable
    style="z-index: 1050; display: flex; justify-content: center"
  >
    <div class="modal-search-filter">
      <DetailFilterFields v-bind="$props" v-on="$listeners" />
    </div>
    <div class="modal-fixbottom">
      <button class="modal-clearbtn" @click="clearDetail">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#adadad"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="inline-block mb-1"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
        選択をクリア
      </button>
      <button class="modal-primarybtn" @click.prevent="$modal.hide('detail-select')">決定</button>
    </div>
  </modal>
</template>

<script>
import DetailFilterFields from './DetailFilterFields.vue'

export default {
  components: {
    DetailFilterFields,
  },
  // Same props as DetailFilterFields; declared here so v-bind="$props" forwards them.
  props: DetailFilterFields.props,
  methods: {
    clearDetail() {
      this.$emit('clearDetail')
    },
  },
}
</script>
